<template>
  <v-container class="pt-0">
    <v-card>
      <v-row>
        <v-col cols="6">
          <v-row class="px-4">
            <v-col cols="12">
              <v-card-title class="pa-0">
                Import & Sync Attendance
              </v-card-title>
            </v-col>
            <v-spacer />
          </v-row> 

          <v-row class="px-4">
            <v-col cols="12">
              1. <span class="font-weight-bold">Upload</span> door attendance. <import-attendances-attendance-dialog-import
                v-if="$hasPermissionTo(['import attendances'])"
                @imported="emit"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              2. <span class="font-weight-bold">Sync</span> mobile clock-in records.
            </v-col>
          </v-row>

          <v-row
            class="px-4 pb-3"
            no-gutters
          >
            <v-col cols="5">
              <v-autocomplete
                v-model="month"
                v-validate="'required'"
                :items="months"
                label="Month"
                :error-messages="errors.collect('month')"
                data-vv-name="month"
                data-vv-as="month"
                hide-selected
                item-text="name"
                item-value="id"
              />
            </v-col>

            <v-col class="ma-auto mx-2">
              <v-row>
                <v-btn
                  v-if="$hasPermissionTo(['import attendances'])"
                  class="mx-3 white--text"
                  color="hrissecondary"
                  :loading="loading"
                  @click="sync"
                >
                  sync
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        
        <v-col cols="6">
          <attendances-attendance-delete
            ref="deleted"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      ImportAttendancesAttendanceDialogImport: () => import('@/components/import/attendances/DialogImport'),
      AttendancesAttendanceDelete: () => import('@/components/attendances/AttendanceDelete'),
    },
    data () {
      return {
        loading: false,
        month: null,
        months: [],
      }
    },
    created () {
      this.$api.employeeClockInSessions().listClockInSessionDate()
        .then(res => {
          this.months = _.orderBy(res.data.map(monthYear => {
            return {
              id: this.$moment(monthYear, 'MM YYYY').format('YYYY-MM'),
              name: this.$moment(monthYear, 'MM YYYY').format('MMM YYYY'),
            }
          }), ['id'], ['desc'])   
        })
    },
    methods: {
      emit () {
        this.$emit('imported')
        this.$refs.deleted.loadData()
      },
      sync () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.loading = true

            this.$api.attendances().sync({ month: this.month })
              .then(res => {
                this.loading = false
                this.$snack({ message: 'Sync completed' })
              }).catch(() => {
                this.loading = false
                this.$snack({ color: 'error', message: 'Error! Please contact IT support' })
              })
          })
      },
    },
  }
</script>
